import { mediaQuery } from "shared/styles/mixins"
import styled from "styled-components"

export const TextInputWrapper = styled.div`
  width: 100%;
  height: ${(props) => props.theme.input.height};
  margin: 0;
  padding: 8px;

  border-width: ${(props) => props.theme.input.borderWidth};
  border-color: ${(props) => props.theme.colors.med};
  border-radius: ${(props) => props.theme.input.borderRadius};
  border-style: solid;

  color: ${(props) => props.theme.colors.dark};
  font-size: ${(props) => props.theme.input.textSize};
  line-height: 1;

  &:focus-within {
    border-color: ${(props) => props.theme.colors.dark};
  }

  ${mediaQuery.mobileDevice} {
    height: ${(props) => props.theme.mobile.input.height};
  }
`

export const TextInput = styled.input`
  background-color: transparent;
  width: 100%;
  height: 100%;
  border: none;
  transition: all 100ms ease-in;
  font-size: ${(props) => props.theme.input.textSize};

  &::placeholder {
    opacity: 1;
    color: ${(props) => props.theme.input.placeholder};
  }

  &:focus,
  &:active {
    outline: none;
  }

  &:invalid {
    outline: none;
    box-shadow: none;
  }
`
